function toValidDate(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function rowInPeriod(muestra, rangeStart, rangeEnd) {
  const startMs = rangeStart.getTime();
  const endMs = rangeEnd.getTime();
  const fields = [
    muestra.FECHA_PETICION,
    muestra.FECHA_ENVIO,
    muestra.FECHA_RECEPCION,
  ];

  return fields.some((value) => {
    const date = toValidDate(value);
    if (!date) return false;
    const timestamp = date.getTime();
    return timestamp >= startMs && timestamp <= endMs;
  });
}

export function sortMuestrasForExport(a, b) {
  const seasonCmp = (a.TEMPORADA || "").localeCompare(b.TEMPORADA || "", "es", {
    sensitivity: "base",
  });
  if (seasonCmp !== 0) return seasonCmp;

  const brandA = a.MARCA || a.NOMBRE_CLIENTE || "";
  const brandB = b.MARCA || b.NOMBRE_CLIENTE || "";
  const brandCmp = brandA.localeCompare(brandB, "es", {
    sensitivity: "base",
  });
  if (brandCmp !== 0) return brandCmp;

  return (a.MUESTRA || "").localeCompare(b.MUESTRA || "", "es", {
    sensitivity: "base",
  });
}

export function selectMuestrasForExcel(
  muestras,
  { rangeStart, rangeEnd, ignorePeriod = false } = {},
) {
  return (muestras || [])
    .filter(
      (muestra) => ignorePeriod || rowInPeriod(muestra, rangeStart, rangeEnd),
    )
    .sort(sortMuestrasForExport);
}
